
import { supabase } from '@/integrations/supabase/client';

/**
 * Adds a new league to the database, with special handling for Scottish leagues
 */
export const addLeague = async (name: string, selectedCountry: string): Promise<void> => {
  let formattedName = name;
  
  // Add prefixes for Scottish leagues
  if (selectedCountry === 'Scotland') {
    const prefixMap: { [key: string]: string } = {
      'Premier League': '01',
      'Championship': '02',
      'League One': '03',
      'League Two': '04'
    };
    
    // Check if the league name matches any of our known Scottish leagues
    const prefix = prefixMap[name];
    if (prefix) {
      formattedName = `${prefix} ${name}`;
    }
  }

  const { error } = await supabase.from('leagues').insert([{ 
    name: formattedName, 
    country: selectedCountry 
  }]);
  
  if (error) throw error;
};
